import useLoadingPage from 'hooks/UseLoadingPage';

export const SuspenseRouteFallback = () => {
    useLoadingPage(true);

    return null;
};
